import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33fdfb12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaAtividadesProjeto__TipoDeAtividade" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "OTabelaAtividadesProjeto__Codigo" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { key: 1 }

import Column from "primevue/column"
import DataTable, { DataTableCellEditCompleteEvent } from "primevue/datatable"
import Skeleton from "primevue/skeleton"
import { AtividadeDoProjeto } from "@/repositorios/atividadesDoProjeto/atividadesDoProjeto.modelos"

interface Props {
  destino?: string;
  atividadesDoProjeto: AtividadeDoProjeto[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaAtividadesProjeto',
  props: {
    destino: null,
    atividadesDoProjeto: null
  },
  emits: ["atualizarCodigo"],
  setup(__props: any, { emit: emitir }: { emit: ({
  (event: "atualizarCodigo", value: { campo: 'codigo'; novoValor: string; valorAntigo: string; idTipoDeAtividade: string }): void;
}), expose: any, slots: any, attrs: any }) {





const atualizarCampoCodigo = (event: DataTableCellEditCompleteEvent): void => {
  const { value, newValue } = event
  if (event.field === "nome" && !event.data.id) {
    event.data.nome = newValue
  }

  if (event.field === "codigo" && !event.data.id) {
    emitir("atualizarCodigo", {
      campo: "codigo",
      novoValor: newValue,
      valorAntigo: value,
      idTipoDeAtividade: event.data.idTipoDeAtividade,
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    onCellEditComplete: atualizarCampoCodigo,
    class: "OTabelaAtividadesProjeto p-datatable-sm",
    "data-key": "id",
    "data-testid": "OTabelaAtividadesProjeto",
    "edit-mode": "cell",
    paginator: true,
    "responsive-layout": "scroll",
    rows: 5,
    "scroll-height": "400px",
    "striped-rows": "",
    value: __props.atividadesDoProjeto
  }, {
    loading: _withCtx(() => [
      _createVNode(_unref(Skeleton), {
        height: "100%",
        width: "100%"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaAtividadesProjeto__Column",
        field: "nome",
        header: "nome",
        "show-add-button": false,
        "show-filter-operator": false,
        sortable: "",
        style: { width: '50%' }
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(data.nome), 1)
          ])
        ]),
        editor: _withCtx(({ data, field }) => [
          (!data.id)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                "data-testid": "OTabelaAtividadesProjeto_NomeDaAtividadeDoProjeto",
                name: "nome",
                type: "text"
              }, null, 8, _hoisted_2)), [
                [
                  _vModelText,
                  data[field],
                  void 0,
                  { trim: true }
                ]
              ])
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(data.nome), 1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        class: "OTabelaAtividadesProjeto__Column",
        field: "codigo",
        header: "código",
        "show-add-button": false,
        "show-filter-operator": false,
        style: { width: '50%' }
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(data.codigo), 1)
          ])
        ]),
        editor: _withCtx(({ data, field }) => [
          (!data.id)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                class: "OTabelaAtividadesProjeto_CodigoDaAtividadePlanejada",
                "data-testid": "OTabelaAtividadesProjeto_CodigoDaAtividadePlanejada",
                name: "codigo",
                type: "text"
              }, null, 8, _hoisted_5)), [
                [
                  _vModelText,
                  data[field],
                  void 0,
                  { trim: true }
                ]
              ])
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(data.codigo), 1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})